/**
 * OnboardingManagement Component
 * Main component for managing client onboarding - includes link creation and testing
 */

import React from 'react';
import { Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import OnboardingLinkCreator from './OnboardingLinkCreator';
import OnboardingTestPortal from './OnboardingTestPortal';
import styles from './OnboardingManagement.module.css';

const OnboardingManagement = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const isOnDashboard = location.pathname === '/configurations/onboarding';

    if (isOnDashboard) {
        return (
            <div className={styles.dashboard}>
                <div className={styles.header}>
                    <h2>Client Onboarding Management</h2>
                    <p className={styles.subtitle}>
                        Create secure onboarding links and test the client experience
                    </p>
                </div>

                <div className={styles.cardGrid}>
                    <div 
                        className={styles.card}
                        onClick={() => navigate('/configurations/onboarding/create')}
                    >
                        <div className={styles.cardIcon}>🔗</div>
                        <h3>Create Onboarding Link</h3>
                        <p>Generate secure links to send to new clients for registration</p>
                        <button className={styles.cardButton}>
                            Create Link
                        </button>
                    </div>

                    <div 
                        className={styles.card}
                        onClick={() => navigate('/configurations/onboarding/test')}
                    >
                        <div className={styles.cardIcon}>🧪</div>
                        <h3>Test Onboarding Process</h3>
                        <p>Preview and test the client-facing onboarding experience</p>
                        <button className={styles.cardButton}>
                            Test Portal
                        </button>
                    </div>
                </div>

                <div className={styles.infoSection}>
                    <h3>About Client Onboarding</h3>
                    <div className={styles.infoContent}>
                        <p>
                            The client onboarding process provides a secure, user-friendly way for new clients 
                            to register and provide their information. When you create an onboarding link:
                        </p>
                        <ul>
                            <li>A unique, secure link is generated with an expiration date</li>
                            <li>An email is automatically sent to the client with the link</li>
                            <li>The client sees a welcome page with your branding</li>
                            <li>They can save their progress and return later</li>
                            <li>Submitted data is securely stored in the system</li>
                        </ul>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <Routes>
            <Route path="create" element={<OnboardingLinkCreator />} />
            <Route path="test" element={<OnboardingTestPortal />} />
        </Routes>
    );
};

export default OnboardingManagement;
